import type { Schema } from '@/shared/api/contract';

/**
 * Straight from the contract: cubas.domain.schemas.client.
 *
 * The natural key is `code`, the ERP's own customer code, **not the NIF**: one company
 * can hold several cards in the ERP and the NIF repeats between them (contexto §4.7).
 * A client typed by hand has no code until the ERP is integrated.
 */
export type Client = Schema<'ClientRead'>;
export type ClientCreate = Schema<'ClientCreate'>;
export type ClientUpdate = Schema<'ClientUpdate'>;

/** Where a client row came from, in words. */
export const CLIENT_ORIGIN_LABELS: Record<string, string> = {
  manual: 'Alta manual',
  erp_api: 'ERP (servicio web)',
  erp_export: 'ERP (fichero)',
};

/** The address as the quote prints it: street, then postal code and city, then province. */
export function addressLines(client: Client): string[] {
  const locality = [client.postal_code, client.city].filter(Boolean).join(' ');
  return [client.street, locality, client.province].filter((line): line is string =>
    Boolean(line && line.trim()),
  );
}

/** What identifies this client at a glance: the ERP code, or the NIF, or nothing. */
export function clientSubtitle(client: Client): string {
  return [client.code, client.nif].filter(Boolean).join(' · ') || 'Sin código ni NIF';
}
